var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hc-art home-border"},[_c('ul',_vm._l((_vm.defaultList),function(item,index){return _c('li',{key:'defaultList' + index,staticClass:"art-info",on:{"click":function($event){return _vm.gotoTemp(item)}}},[_c('div',{staticClass:"default-banner",style:(item.style)},[_c('p',[_vm._v(_vm._s(item.name))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }